// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModalFooter_footer__gZP0d"};